import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Input, Modal, Spin, useAlert } from './ui';
import axios from 'axios';
import datas from "../Assets/data.json";
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import env from 'react-dotenv';
import { Crypter } from '../Functions/Security/Crypter';
import Hash from '../Functions/Security/Hash';
import { useNavigate } from 'react-router-dom';
import { useAuthHeader } from 'react-auth-kit';
import { clearSessionStorage } from '../Functions/storage';

export default function UpdatePasswordAtFirstConnexion(props: { reccord?: any }) {
  // USER TOKEN
  const authHeader = useAuthHeader()
  const alert = useAlert()

  const formSchema = Yup.object().shape({
    pwd: Yup.string()
      .required('Mot de passe obligatoire')
      .min(8, 'La longuer du mot de passe doit être de huit caractère')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Doit Contenir 8 caractères, Une majuscule, Une minuscule, Un nombre et un caractère spéciale."
      ),
    confirmPwd: Yup.string()
      .required('Confirmation du mot de passe obligatoire')
      .oneOf([Yup.ref('pwd')], 'Les mots de passe ne correspondent pas')
  })


  const formOptions = { resolver: yupResolver(formSchema) }
  const [open, setOpen] = React.useState(true);
  const { register, handleSubmit, setValue, reset, getValues, formState } = useForm(formOptions)
  const [fichier, setFicher] = useState<File>()
  const [isOk, setIsOk] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [pass, setPass] = useState<string>("")
  const [confPass, setConfPass] = useState<string>("")
  const navigat = useNavigate()

  const { errors } = formState

  const onSubmit = async (data: any) => {
    data = { "CodeAbonne": props.reccord?.CodeAbonne, "CodeU": props.reccord?.CodeU, "CodeS": props.reccord?.CodeS, "mdp": Hash(confPass), "CodeFiliale": props.reccord?.CodeFiliale }
    setLoading(true)
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: env.API_BASE_URL + datas.API_LINKs.UpdateFirstPass,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
      },
      data: Crypter.encrypt(JSON.stringify(data))
    };

    axios.request(config)
      .then((response) => {
        setLoading(false)
        const res = JSON.parse(Crypter.decrypt(response.data)).Value
        if (res.StatutCode == 200) {
          // localStorage.setItem("openUpdatePassModal", "0")
          setOpen(false)
          alert.success(res.Message)
          reset()
          navigat("/Login")
          clearSessionStorage()
        } else {
          alert.warning(res.Message)
        }
      })
      .catch((error) => {
        setLoading(false)
        alert.error(error.message)
      });

  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    localStorage.removeItem("openUpdatePassModal");
    setOpen(false);
  };

  // function onsubmit() {
  //   alert(JSON.stringify(register))
  // }
  // setTimeout(() => {
  //   try {

  //     let open = localStorage.getItem("openUpdatePassModal");
  //     if (open == "1") {
  //       setOpen(true)
  //     }
  //     else if (open == "0") {
  //       setOpen(false)
  //     }
  //     localStorage.removeItem("openUpdatePassModal");
  //   }
  //   catch (e) { }
  // }, 1)
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        width={560}
        title={
          <>
            Modification de Mot de passe / <span className="text-[80%] text-[var(--eb-text-muted)] font-normal">{(props.reccord?.Name + " " + props.reccord?.Prenom).substring(0, 20)} {(props.reccord?.Name + " " + props.reccord?.Prenom).substring(0, 20).length <= (props.reccord?.Name + " " + props.reccord?.Prenom).length ? "" : "..."}</span>
          </>
        }
      >
        <center><img style={{ borderRadius: "100%", border: "5px rgba(161, 10, 164, 1) solid" }} width={100} height={100} src={props.reccord?.Image} /></center>
        <p className="text-sm text-[var(--eb-text-muted)] mt-2">Veillez Changer votre mot de passe. Votre mot de passe est confidentiel.</p>
        <br />
        <Spin spinning={loading}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='round0'>{/*className='round0'*/}
              <div className='ressource'>
                <div className="flex gap-3">
                  <Input
                    required
                    type='text'
                    disabled={props.reccord?.CodeU != undefined}
                    value={props.reccord?.CodeU}
                    label='CodeU' />
                  <Input
                    required
                    type='text'
                    disabled={props.reccord?.Mobile != undefined}
                    value={props.reccord?.Mobile}
                    label='Mobile' />
                </div>
                <br />
                <div className="flex gap-3">
                  <Input
                    {...register("pwd")}
                    helperText={errors.pwd != undefined ? errors.pwd.message + "" : ""}
                    error={errors.pwd != undefined}
                    onChange={(e) => { setPass(e.target.value) }}
                    required
                    type='password'
                    label='Nouveau mot de passe'
                    placeholder="Entrez le nouveau mot de passe" />
                  <Input
                    {...register("confirmPwd")}
                    helperText={errors.confirmPwd != undefined ? errors.confirmPwd.message + "" : ""}
                    error={errors.confirmPwd != undefined}
                    onChange={(e) => { setConfPass(e.target.value) }}
                    required
                    type='password'
                    label='Confirmation'
                    placeholder="Confirmez le mot de passe" />
                </div>
                <br /><br />
                <div className="flex gap-2">
                  <Button variant="outline" className="text-red-600 border-red-300 hover:bg-red-50" onClick={() => { setOpen(false) }}>Anuller</Button>
                  <Button className="w-full" variant="secondary" type='submit'>Enregistrer</Button>
                </div>
              </div>
            </div>

          </form>
        </Spin>
      </Modal>
    </div>
  );
}
